import React, { useContext } from "react"
import { Container, LoaderContainer } from "./styles"
import Loader from "react-loader-spinner";
import { ThemeContext } from "styled-components";

export const LoadingOverlay = ({ dialogMessage }) => {
    const { colors } = useContext(ThemeContext);

    return (
        <Container>
            <div>
                <LoaderContainer className="loader-container">
                    <Loader
                        type="ThreeDots"
                        color={colors.primary}
                        height={25}
                        width={25}
                    />
                </LoaderContainer>

                <span>{dialogMessage.toLowerCase()}</span>
            </div>
        </Container>
    )
}